// extracted by mini-css-extract-plugin
export var notFoundPage = "_404-module--notFoundPage--3v79q";
export var notFoundHeader = "_404-module--notFoundHeader--2U4MJ";
export var leftCable = "_404-module--leftCable--vrjQf";
export var rightCable = "_404-module--rightCable--J6jU8";